import * as u from './utils';

export default () => {
    const dialogs = document.querySelectorAll('dialog');

    for (const dialog of dialogs) {
        if (!dialog.closest('.video-grid')) {
            return;
        }

        dialog.addEventListener('dialog-open', handleOpen);
        dialog.addEventListener('dialog-close', handleClose);
    }

    function handleOpen(e) {
        const dialog = e.currentTarget;

        setTimeout(() => {
            // Trigger the video if its a locally hosted video
            const mejsPlayer = dialog.querySelector('mediaelementwrapper');
            const video = dialog.querySelector('video');
            if (mejsPlayer) {
                mejsPlayer.play();
            } else if (video) {
                video.play();
            }

            u.trigger('resize', window);
        }, 200);
    }

    function handleClose(e) {
        const dialog = e.currentTarget;

        // Make sure any video inside is stopped
        const mejsPlayer = dialog.querySelector('mediaelementwrapper');
        const video = dialog.querySelector('video');
        if (mejsPlayer && !mejsPlayer.paused) {
            mejsPlayer.pause();
        } else if (video && !video.paused) {
            video.pause();
        }
    }
};
